export const LOGIN_METHOD_WITH_SUB_FORM_TYPES = [
    "general",
    "edu-student-pre-register",
    "edu-student-pre-register-combine",
    "edu-officer-pre-register",
    "time-attendance-pre-register",
    "corporation-pre-register",
];

/**
 * เช็คว่าชื่อ idp นี้มี checkbox hardcode แยกต่างหากสำหรับ formType ปัจจุบันหรือไม่
 * (ใช้กรอง idp.map ไม่ให้ขึ้นซ้ำกับ checkbox hardcode)
 *
 * ต้องเช็คแบบผูกกับ formType เท่านั้น ห้ามกรองแบบ static list ตายตัว เพราะแต่ละชื่อ
 * มี hardcode checkbox เฉพาะบาง formType เท่านั้น (เช่น ThaID มีเฉพาะ general-lms)
 * formType อื่นที่ backend ส่ง ThaID มาใน idp_list (เช่น combine type) ต้องปล่อยให้
 * ขึ้นผ่าน idp.map ตามปกติ ไม่งั้นจะหายไปทั้งที่ไม่มีอะไรชนกันเลย
 */
export const isHardcodedLoginCheckbox = (name, formType) => {
    if (name === "ThaID") return formType === "general-lms";
    if (name === "Zimbra") return formType === "corporation-mail";
    if (name === "OneID") return LOGIN_METHOD_WITH_SUB_FORM_TYPES.includes(formType);
    return false;
};

export const getValidLoginMethods = (loginMethod, formType) => {
    if (!Array.isArray(loginMethod)) return loginMethod;

    const isCorporationMail = formType === "corporation-mail";
    const isOneIdType = LOGIN_METHOD_WITH_SUB_FORM_TYPES.includes(formType);

    return loginMethod.filter((item) => {
        if (item.name === "Zimbra") return isCorporationMail;
        if (item.name === "OneID") return isOneIdType;
        // ThaID กับรายการอื่นจาก idp (Azure/Google/Facebook/OneCollab/MophDID ฯลฯ)
        // ใช้กฎเดียวกับ idp ทั่วไป: ซ่อนเฉพาะตอน corporation-mail (idp ถูกกรองทิ้งทั้งหมด)
        return !isCorporationMail;
    });
};